
import throttle from "lodash.throttle";
import { getClient } from "Globals/api";
import gql from "graphql-tag.macro";
import { createSelector } from "reselect";

const shortenTokenMutation = gql`
    mutation shortenToken($access_token: String!) {
        shortenToken(access_token: $access_token)
    }
`;

export const getMDShortCutToken = createSelector(
    token => token, 
    async token => {
        if (token?.length > 10 && (new TextEncoder().encode(token)).length > (1000 * 5)) {
            const client = await getClient("MDshortCutToken");
            const { data: { shortenToken } } = await client.mutate({
                mutation: shortenTokenMutation,
                variables: { access_token: token },
            });

            return shortenToken;
        }
        return token;
    }
);
